import { cssGenerator, hdrm } from '@yola/ws-sdk';

const regenerateAtomicCSS = async (config, payload) => {
  const { elementId, attr } = payload;
  if (attr) {
    const attributes = cssGenerator.generator.getAttributes();

    if (!elementId || !attributes.includes(attr)) {
      return [];
    }
  }

  const staticDOM = hdrm.instance.driver.getStaticDocument();
  const css = await cssGenerator.operations.generateCssFromHtml(staticDOM.body.innerHTML);

  return [
    {
      instructions: [
        {
          regenerateCSS: true,
          css,
        },
      ],
    },
  ];
};

export default regenerateAtomicCSS;
